import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import CLOSE from "../../assets/images/icons/close.svg";
import Button from "../buttons/buttons";
import { Beat } from "../../plugins/spinners.plugin";
import successHandler from "../../handlers/successHandler";
import {
  deletePaymentInstrument,
  getMyPaymentInstruments,
} from "../../redux/paymentInstrument/paymentInstrumentActions";

export function DeleteCardModal({ show, onClose, id }) {
  const dispatch = useDispatch();

  const { deleting } = useSelector((state) => state.paymentInstrument);

  const handleDelete = async () => {
    if (!id) return;

    try {
      const response = await dispatch(deletePaymentInstrument({ id }));
      if (response) {
        successHandler(response, true);
        // Refresh the payment instruments list
        await dispatch(getMyPaymentInstruments());
        // Close the modal
        onClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[415px] sm:w-[600px] bg-white dark:bg-[#121212] rounded-md py-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg">
                  <div>
                    <div className="sm:block absolute top-4 right-5">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-md p-1 sm:p-3"
                        onClick={onClose}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className="w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>
                    <div className="sm:flex justify-center">
                      <div className="text-center sm:text-center mt-2">
                        <Dialog.Title
                          as="h3"
                          className="text-xl font-medium text-black dark:text-white"
                        >
                          Delete Card
                        </Dialog.Title>
                      </div>
                    </div>
                  </div>

                  <div className="border-b-2 mt-4"></div>
                  <div className="mt-5 sm:mt-7 sm:px-8 p-4">
                    <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
                      Are you sure you want to delete this card? This action cannot be undone.
                    </p>
                    <div className="flex gap-4">
                      <Button.Secondary
                        title="Cancel"
                        onClick={onClose}
                        className="flex-1"
                      />
                      <Button.Primary
                        title={deleting ? <Beat color={"#ffffff"}  /> : "Delete"}
                        disabled={deleting}
                        onClick={handleDelete}
                        className="flex-1 !bg-red-600 hover:!bg-red-700"
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
